import { useState } from "react";
import { FaStar } from "react-icons/fa";
import styles from "../styles/starRating.module.css"; // Import CSS for styling

const StarRating = ({ onRatingChange }) => {
    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);

    const handleClick = (index) => {
        setRating(index);
        if (onRatingChange) {
            onRatingChange(index);
        }
    };

    return (
        <div className={styles.starContainer}>
            {[1, 2, 3, 4, 5].map((index) => (
                <FaStar
                    key={index}
                    size={40}
                    className={styles.star}
                    color={(hover || rating) >= index ? "#FFD700" : "#ccc"} // Gold for selected stars
                    onClick={() => handleClick(index)}
                    onMouseEnter={() => setHover(index)}
                    onMouseLeave={() => setHover(rating)}
                />
            ))}
        </div>
    );
};

export default StarRating;

